module.exports = __webpack_public_path__ + "static/media/19.b61081ab.jpg";